import React, { useEffect } from "react";
import { CategoryInterface } from "../../../../store/roblox/categoriesSlice";

import {Button, Form, Input, Radio} from "antd";
import './_Form.scss';

interface propsInterface {
  params: CategoryInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Form.Item label="Target" name='target'>
        <Radio.Group>
          <Radio value='patterns'>Patterns</Radio>
          <Radio value='accessories'>Accessories</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
